import React from 'react'

import { Phantom, Footer } from './styles'

interface IPageFooterProps {
  children: React.ReactNode
  phantomHeight?: string
  bottomPosition?: string,
  style?: React.CSSProperties
}

const PageFooter: React.FC<IPageFooterProps> = (props) => {
  return (
    <footer>
      <Phantom phantomHeight={props.phantomHeight} />
      <Footer bottomPosition={props.bottomPosition}>{props.children}</Footer>
    </footer>
  )
}

export default PageFooter
